// src/PageA.js

// Assuming the Ballpit component is available in the same directory or correctly imported
import Waves from './Waves.js'; 

const PageB = () => {
 // Dependency array: Re-run only if 'navigate' changes (it won't, but ESLint likes it)
  return (
    // Outer div creates the full-screen black container, hiding overflow
    <div style={{
        backgroundColor:'#000000',
        position: 'relative', 
        overflow: 'hidden', 
        minHeight: '100vh', 
        maxHeight: '100vh', 
        width: '100%'
    }}>
      {/* Renders the Ballpit simulation with specific physics and colors */}
      

<Waves
  lineColor="#fff"
  backgroundColor="rgba(255, 255, 255, 0.2)"
  waveSpeedX={0.02}
  waveSpeedY={0.01}
  waveAmpX={40}
  waveAmpY={20}
  friction={0.9}
  tension={0.01}
  maxCursorMove={120}
  xGap={12}
  yGap={36}
/>
    </div>
  );
};

export default PageB;